/**
 * @description Sauvegarde dans session storage (stockage de l'onglet)
 * des paramètres pour les faire persister en cas de rechargement de la page
 *
 * @param { Object } params
 *
 * @param { String } params.pathname pathname de la page
 * @param { String } [params.date] date de la réservation
 * @param { String } [params.type] type d'espace
**/
export function updateSessionStorage({
  pathname,
  date,
  type
}) {
  const STORAGE_NAME = 'front-page-get-params@' + pathname;

  // écrase les potentiels paramètres get préexistants de la page
  const get_params = getSessionStorage({
    pathname
  });
  if (typeof date !== 'undefined') get_params.date = date;
  if (typeof type !== 'undefined') get_params.type = type;
  window.sessionStorage.setItem(STORAGE_NAME, JSON.stringify(get_params));
}

/**
 * 
 * @param { Object } params
 * @param { String } params.pathname pathname de la page
 *
 * @returns { Object<string> } valeurs stockées sous forme d'objet
 */
export function getSessionStorage({
  pathname
}) {
  const STORAGE_NAME = 'front-page-get-params@' + pathname;
  const storage_string = window.sessionStorage.getItem(STORAGE_NAME);
  if (!storage_string) return {};
  try {
    return JSON.parse(storage_string);
  } catch (e) {
    window.sessionStorage.removeItem(STORAGE_NAME);
    return {};
  }
}
